import Endpoints from '../../constants/Endpoints';
import axios from '../axiosInstance';

const getAssetQuery = async () => {
  const res = await axios.get<never, any[]>(Endpoints.Query.GetAssets);
  return res;
};

const getChainsQuery = async () => {
  const res = await axios.get<never, any[]>(Endpoints.Query.GetChains);
  return res;
};

const getMerchantListQuery = async () => {
  const res = await axios.get<never, any[]>(Endpoints.Query.GetMerchantList);
  return res;
};

const apis = { getAssetQuery, getChainsQuery, getMerchantListQuery };

export default apis;
